import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { cancel } from "../../assets/icons";
import { useQueries } from "../../helpers/query_searchParams/QuerySearchParams";

interface IProps {
  dispatchContext: any;
  stateContext: any;
  queryParams?: any;
}

const NewChip: React.FC<IProps> = ({
  dispatchContext,
  stateContext,
  queryParams,
}) => {
  const query = useQueries(useLocation);
  const { search, pathname, hash } = useLocation();
  const history = useHistory();
  const { chip } = stateContext;

  const handleChipByKey = (el: any) => {
    console.log(el);
    const new_data = chip.filter((item: any) => item !== el);
    dispatchContext({
      type: "handle_chip",
      payload: new_data,
    });
    for (const key in queryParams) {
      let new_search;
      let value: any = query.get(queryParams[key].real_name);
      if (value && queryParams[key].show_name === el) {
        new_search = search.replace(
          `&&${queryParams[+key].real_name}=${value.split(" ").join("%20")}`,
          ""
        );
        history.push({ pathname, search: new_search, hash });
      }
    }
  };

  return (
    <div>
      {chip && (
        <div className="md:flex hidden">
          {chip.map((el: any, idx:number) => (
            <div
              key={idx}
              className="inline-flex items-center rounded mr-3 bg-white border-2 border-softGray p-1 mt-1"
            >
              <span className="px-2 text-sm">{el.split("_").join(" ")}</span>
              <button type="button" className="h-6 w-6 p-1 focus:outline-none">
                <img
                  onClick={() => handleChipByKey(el)}
                  src={cancel}
                  alt="cancel"
                  className="cursor-pointer w-2.5"
                />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NewChip;
